
const PERMISSIONS = {};
const RESULTS = {
	GRANTED: ""
}

export { PERMISSIONS, RESULTS };

export const openLimitedPhotoLibraryPicker = async () => { };
export const openSettings = async () => { };
export const check = async (permission) => RESULTS.GRANTED;
export const request = async (permission) => RESULTS.GRANTED;
export const checkLocationAccuracy = async () => 'full';
export const requestLocationAccuracy = async (options) => 'full';

const notificationOptions = [
	'alert',
	'badge',
	'sound',
	'carPlay',
	'criticalAlert',
	'provisional',
	'providesAppSettings',
];

const notificationSettings = {
	alert: true,
	badge: true,
	sound: true,
	carPlay: true,
	criticalAlert: true,
	provisional: true,
	providesAppSettings: true,
	lockScreen: true,
	notificationCenter: true,
};

export const checkNotifications = async () => ({
	status: RESULTS.GRANTED,
	settings: notificationSettings,
})

export const requestNotifications = async (options) => ({
	status: RESULTS.GRANTED,
	settings: options
		.filter((option) => notificationOptions.includes(option))
		.reduce((acc, option) => ({ ...acc, [option]: true }), {
			lockScreen: true,
			notificationCenter: true,
		}),
})

export const checkMultiple = async (permissions) =>
	permissions.reduce((acc, permission) => ({ ...acc, [permission]: RESULTS.GRANTED }), {})


export const requestMultiple = async (permissions) =>
	permissions.reduce((acc, permission) => ({ ...acc, [permission]: RESULTS.GRANTED }), {})

export default {
	PERMISSIONS,
	RESULTS,

	check,
	checkLocationAccuracy,
	checkMultiple,
	checkNotifications,
	openLimitedPhotoLibraryPicker,
	openSettings,
	request,
	requestLocationAccuracy,
	requestMultiple,
	requestNotifications,
};
